<template>
    <div class="divisor-icone d-flex bd-highlight align-items-center">        
        <div class="d-flex align-items-center" v-if="icon != null || title != null">
            <span :class="'txt-h-2 txt-blue-2 me-2 txt-size-'+iconSize" v-if="icon != null">
                <i :class="icon"></i>
            </span>
            <span :class="'txt-h-2 txt-blue-2 me-3 txt-size-'+textSize" v-if="title != null">
                {{title}}
            </span>
        </div>
        <div class="divisor-horizontal flex-grow-1 "></div>
        <span class="ms-3 txt-h-6 txt-size-14 txt-white bg-blue-2 px-2 py-1 rounded " v-if="tag">
            {{tag}}
        </span>
    </div>
</template>

<script>

    export default {
        name: 'DivisorIcone',
        props: {
            icon: {
                type: String,
                default: null
            },
            title: {
                type: String,
                default: null
            },
            tag: {
                type: String,
                default: null
            },
            iconSize: {
                type: Number,
                default: 24,
            },
            textSize: {
                type: Number,
                default: 28,
            },
        },
        data: function () {
            return {
                
            }
        },
        methods: {
            
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .divisor-horizontal {
        border-top: 2px solid color('blue','2');
    }
</style>

